import { useThemeToggle } from '../contexts/ThemeContext';
import { getDmsPalette } from '../theme/dmsTheme';

export default function useDmsPalette() {
  const { mode } = useThemeToggle();
  return getDmsPalette(mode);
}